import React, { useEffect, useState } from "react";
import Layout from "../../page/layout";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getMe } from "../../features/authSlice";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Breadcrumb,
  Alert,
  Card,
} from "react-bootstrap";
import SuccessModalTanam from "../../component/ModalSuccessRencanaTanam";

const AddRencanaTanam = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);

  const [tanggalRencanaTanam, settanggalRencanaTanam] = useState("");
  const [tanggalRencanaPanen, settanggalRencanaPanen] = useState("");
  const [varietassingkong, setvarietassingkong] = useState("");
  const [estimasiproduksi, setestimasiproduksi] = useState("");
  const [catatantambahan, setcatatantambahan] = useState("");
  const [jenispupuk, setjenispupuk] = useState("");
  const [jumlahpupuk, setjumlahpupuk] = useState("");
  const [lahanOptions, setLahanOptions] = useState([]);
  const [selectedLahan, setSelectedLahan] = useState("");
  const [msg, setMsg] = useState("");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      try {
        const responseLahan = await axios.get(
          "https://c-greenproject.org:8000/lahan",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setLahanOptions(responseLahan.data);
      } catch (error) {
        setMsg("Gagal mengambil data lahan.");
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
    if (user && user.role !== "admin" && user.role !== "petani") {
      navigate("/dashboard");
    }
  }, [isError, user, navigate]);

  const savePetani = async (e) => {
    e.preventDefault();

    if (!selectedLahan) {
      setMsg("Silakan pilih lahan terlebih dahulu.");
      return;
    }

    const token = localStorage.getItem("token");

    try {
      await axios.post(
        "https://c-greenproject.org:8000/petani",
        {
          idlahan: selectedLahan, 
          tanggalRencanaTanam,
          tanggalRencanaPanen,
          varietassingkong,
          estimasiproduksi,
          catatantambahan,
          jenispupuk,
          jumlahpupuk,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setShowModal(true);
      
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data?.msg || "Terjadi kesalahan pada server.");
      } else {
        setMsg("Gagal menghubungi server. Periksa koneksi internet Anda.");
      }
    }
  };

  return (
    <Layout>
      <Container>
        <Breadcrumb>
          <Breadcrumb.Item href="/rencanatanam">Rencana Tanam</Breadcrumb.Item>
          <Breadcrumb.Item active>Tambah Rencana Tanam</Breadcrumb.Item>
        </Breadcrumb>
        <h2 className="mb-4">
          <strong>Tambah Rencana Tanam</strong>
        </h2>
        {msg && <Alert variant="danger">{msg}</Alert>}
        <Card className="p-4 mb-3 shadow">
          <Form onSubmit={savePetani}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>ID Lahan</Form.Label>
                  <Form.Select
                    value={selectedLahan}
                    onChange={(e) => setSelectedLahan(e.target.value)}
                  >
                    <option value="">Pilih Lahan</option>
                    {lahanOptions.length > 0 ? (
                      lahanOptions.map((lahan) => (
                        <option key={lahan.id} value={lahan.id}>
                          {lahan}{" "}
                        </option>
                      ))
                    ) : (
                      <option disabled>Tidak ada data lahan</option>
                    )}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Tanggal Rencana Tanam</Form.Label>
                  <Form.Control
                    type="date"
                    value={tanggalRencanaTanam}
                    onChange={(e) => settanggalRencanaTanam(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Tanggal Rencana Panen</Form.Label>
                  <Form.Control
                    type="date"
                    value={tanggalRencanaPanen}
                    onChange={(e) => settanggalRencanaPanen(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Varietas Singkong</Form.Label>
                  <Form.Select
                    value={varietassingkong}
                    onChange={(e) => setvarietassingkong(e.target.value)}
                  >
                    <option value="">Pilih Varietas</option>
                    <option value="Grade A">Grade A</option>
                    <option value="Grade B">Grade B</option>
                    <option value="Grade C">Grade C</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Estimasi Produksi (kg)</Form.Label>
                  <Form.Control
                    type="number"
                    value={estimasiproduksi}
                    onChange={(e) => setestimasiproduksi(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Jenis Pupuk</Form.Label>
                  <Form.Control
                    type="text"
                    value={jenispupuk}
                    onChange={(e) => setjenispupuk(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Jumlah Pupuk (kg)</Form.Label>
                  <Form.Control
                    type="number"
                    value={jumlahpupuk}
                    onChange={(e) => setjumlahpupuk(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Catatan Tambahan</Form.Label>
                  <Form.Control
                    as="textarea"
                    value={catatantambahan}
                    onChange={(e) => setcatatantambahan(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Button type="submit" variant="success">
              Simpan
            </Button>
          </Form>
        </Card>
      </Container>
      <SuccessModalTanam
        show={showModal}
        onClose={() => setShowModal(false)}
        message="Rencana tanam berhasil ditambahkan."
      />
    </Layout>
  );
};

export default AddRencanaTanam;
